"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("@powerednow/shared/constants");
const lodash_1 = __importDefault(require("lodash"));
const bluebird_1 = __importDefault(require("bluebird"));
const Renderer_1 = __importDefault(require("../../classes/Renderer"));
class JobItemGroupRenderData extends Renderer_1.default {
    async getJobItems() {
        return this.item.getAllJobItem();
    }
    async isTaxUsed() {
        const jobItems = await this.getJobItems();
        return Boolean(jobItems[0]?.data.use_tax);
    }
    async isTaxInclusive() {
        const jobItems = await this.getJobItems();
        return Boolean(jobItems[0].data.is_inclusive);
    }
    async getLayoutForJobItemGroup() {
        const document = await this.item.getDocument();
        const company = await document.getCompany();
        const pricedItemLayoutKey = constants_1.DOCUMENT.LAYOUT_KEYS_BY_DOCUMENT_TYPE[document.data.type];
        const defaultLayout = company.constructor.Entity.fields.find(item => item.name === pricedItemLayoutKey)?.defaultValue;
        const defaultLayoutValues = typeof defaultLayout === 'string' ? JSON.parse(defaultLayout) : defaultLayout;
        const defaultLayoutValuesBoolean = lodash_1.default.mapValues(defaultLayoutValues, value => Boolean(value));
        const userTaxRate = await this.item.getUserTaxRate();
        const companyLayoutSettings = company.data[pricedItemLayoutKey];
        const jobItemGroupLayoutSettings = this.item.data[pricedItemLayoutKey];
        const mergedLayoutSettings = { ...defaultLayoutValuesBoolean, ...companyLayoutSettings, ...jobItemGroupLayoutSettings };
        const isTaxInclusive = !(await this.isTaxUsed()) || await this.isTaxInclusive();
        // todo some document types will have an extra first part...
        const typesWhereDoubleShiftNeeded = [constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE_CREDIT, constants_1.DOCUMENT.TYPES_VALUES.EXPENSE_CREDITNOTE, constants_1.DOCUMENT.TYPES_VALUES.PURCHASE_ORDER];
        const layoutData = lodash_1.default.mapKeys(mergedLayoutSettings, (value, key) => {
            const parts = key.split('_');
            parts.shift();
            if (typesWhereDoubleShiftNeeded.includes(document.data.type)) {
                parts.shift();
            }
            return parts.join('_');
        });
        if (userTaxRate) {
            layoutData.taxRate = `${userTaxRate.data.rate}%`;
        }
        layoutData.tax_inclusive = isTaxInclusive;
        layoutData.vat_registered = await this.isTaxUsed();
        layoutData.show_subtotal = this.item.data.subtotal !== this.item.data.total && Boolean(layoutData.show_subtotal);
        if (!(await this.isTaxUsed()) || document.data.is_disbursement) {
            layoutData.show_vat = false;
            layoutData.show_vat_indicator = false;
            layoutData.show_vat_rate = false;
            layoutData.show_vat_amount = false;
            layoutData.show_line_total = false;
        }
        if (document.data.is_disbursement) {
            layoutData.show_amount = false;
            layoutData.show_unit_cost = false;
            layoutData.show_total = true;
            layoutData.show_line_total = true;
        }
        if (isTaxInclusive) {
            layoutData.show_line_total = false;
        }
        return layoutData;
    }
    async getJobItemsData() {
        const jobItems = await this.item.getAllJobItem();
        const sortedJobItems = jobItems.sort((a, b) => a.data.sequence - b.data.sequence);
        const document = await this.item.getDocument();
        const company = await document.getCompany();
        const productLinkSetting = await company.getCompanySettingOrNull(constants_1.SETTINGS_KEYS.DISPLAY_PRODUCT_LINK);
        const showProductLink = Boolean(JSON.parse((productLinkSetting || false).toString()));
        return bluebird_1.default.map(sortedJobItems, async (jobItem) => {
            const userTaxRate = await jobItem.getUserTaxRate();
            const product_link = showProductLink ? jobItem.data.product_link : null;
            return {
                sku: jobItem.data.sku,
                description: jobItem.data.description,
                quantity: jobItem.data.quantity,
                unitcost: jobItem.data.unitcost,
                exclusive_cost: jobItem.data.exclusive_cost,
                vat: jobItem.data.vat,
                display_rate: userTaxRate ? userTaxRate.data.rate : jobItem.data.vat_rate,
                cis_value: jobItem.data.cis_value,
                category_is_cis: jobItem.data.category_is_cis,
                is_cis: jobItem.data.is_cis,
                product_link,
            };
        });
    }
    getDiscountLabel() {
        const { discount_description: description } = this.item.data;
        if (description && description !== '') {
            return description;
        }
        return this.item.data.is_surcharge ? this.L('DocumentView.Markup', 'Mark up') : this.L('DocumentView.Discount', 'Discount');
    }
    async getDocumentTemplateData() {
        const documentItem = await this.item.getDocumentItem();
        return {
            data: {
                title: this.item.data.title,
                description: this.item.data.description,
                description_has_value: Boolean(this.item.data.description?.length),
                discount: this.item.data.discount,
                subtotal: this.item.data.subtotal,
                vat: this.item.data.vat,
                cis_total: this.item.data.cis_total,
                cis_explanation: this.item.data.cis_explanation,
                total: this.item.data.total,
            },
            jobItems: await this.getJobItemsData(),
            layout: await this.getLayoutForJobItemGroup(),
            discountLabel: await this.getDiscountLabel(),
            type: documentItem.data.type,
        };
    }
}
exports.default = JobItemGroupRenderData;
//# sourceMappingURL=../../../../src/models/jobItemGroup/renderData.js.map